import { useEffect, useState } from "react";
import { PartyPopper } from "lucide-react";
import { api } from "@/lib/api";
import { UserAvatar, UserLink } from "@/components/UserBits";

export function SupporterCongrats({ userId, isMe }) {
  const [d, setD] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => { api.get(`/users/${userId}/supporter-congrats`).then(({ data }) => setD(data)).catch(() => {}); }, [userId]);
  if (!d || d.total === 0) return null;
  const shown = all ? d.users : d.users.slice(0, 8);
  return (
    <div className="fade-up relative overflow-hidden rounded-3xl p-5 border border-orange-100 bg-gradient-to-br from-orange-50 via-white to-pink-50" data-testid="supporter-congrats-card">
      <p className="font-bold flex items-center gap-2"><PartyPopper className="w-5 h-5 text-orange-500" /> Glückwünsche zum Projekt Unterstützer</p>
      <p className="text-sm text-slate-500 mt-0.5" data-testid="supporter-congrats-total">
        {d.total} {d.total === 1 ? "Mitglied hat" : "Mitglieder haben"}{isMe ? " dir" : ""} gratuliert 🧡
      </p>
      <ul className="mt-3 space-y-2">
        {shown.map((u) => (
          <li key={u.user_id} className="flex items-center gap-2.5" data-testid={`supporter-congrats-user-${u.user_id}`}>
            <UserAvatar userId={u.user_id} name={u.name} picture={u.picture} size="w-8 h-8" text="text-xs" />
            <UserLink id={u.user_id} className="text-sm font-semibold truncate">{u.name}</UserLink>
          </li>
        ))}
      </ul>
      {d.users.length > 8 && <button onClick={() => setAll(!all)} data-testid="supporter-congrats-toggle" className="mt-3 text-sm font-semibold text-rose-600 hover:underline">{all ? "Weniger anzeigen" : `Alle ${d.users.length} anzeigen`}</button>}
    </div>
  );
}
